module.exports = __webpack_public_path__ + "static/media/spinach_620x350_81477995047.1c8a3e0f.jpg";